import angular from "angular";

import Assert from "tbAssert";

import UserInfoServiceModule from "./UserInfoService";

const mUserInfoSvc = new WeakMap();

const destinationStateForEditEnabledUser = "trackingEvent";
const destinationStateForOtherUsers = "trackingCalendarEventView";

class EventTitleGridTemplateBuilderService {
    constructor(UserInfoService) {
        Assert.StrictAssert(UserInfoService != null, "Assertion Failure: Missing User Info Service Dependency");

        mUserInfoSvc.set(this, UserInfoService);
    }

    get eventTitleTemplate() {
        let eventDestState = (
            (mUserInfoSvc.get(this).hasTrackerRights) ?
                destinationStateForEditEnabledUser :
                destinationStateForOtherUsers
        );

        return `<a ui-sref="${eventDestState}({ eventId: {{::dataItem.trackingEventId}} })">{{dataItem.displayTitle}}</a>`;
    }

    toString() {
        return "EventTitleGridTemplateBuilder";
    }
}

EventTitleGridTemplateBuilderService.$inject = [ "UserInfoService" ];

export default angular
    .module("trackerbase-app.services.event-title-grid-template-builder", [
        UserInfoServiceModule
    ])
    .service("EventTitleGridTemplateBuilder", EventTitleGridTemplateBuilderService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/EventTitleGridTemplateBuilder.js
// module id = 7UBW
// module chunks = 1